import client from "./requestclient";

const realtor = {
  fetchActivationData: async () => {
    return await client({ URL_PATH: "getactivationdata", method: "GET" });
  },

  bankCodeList: async () => {
    return await client({ URL_PATH: "fetch-bank-and-codes", method: "GET" });
  },

  activateRealtor: async () => {
    return await client({
      URL_PATH: "activaterealtorforbonus",
      method: "POST"
    });
  },
  withdrawActivationBonus: async () => {
    return await client({
      URL_PATH: "withdrawactivationbonus",
      method: "POST"
    });
  },
  validateBankAccount: async body => {
    return await client({
      URL_PATH: "fbn-validate-account-number",
      method: "POST",
      body: body
    });
  },
  savebankdetails: async body => {
    return await client({
      URL_PATH: "update-smart-withdrawal-account",
      method: "POST",
      body: body
    });
  },


};

export default realtor;
